var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',[_c('circle',{attrs:{"cx":"11","cy":"11","r":"11","fill":"#606060"}}),_vm._v(" "),_c('path',{attrs:{"d":"M11 22A11 11 0 1 0 0 11a11 11 0 0 0 11 11zm0-.667A10.333 10.333 0 1 1 21.333 11 10.333 10.333 0 0 1 11 21.333z","fill":"#fff"}})])}
var staticRenderFns = []

export { render, staticRenderFns }